<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
    <div class="t-application-invite-user-upload__instruction">
      <a-heading tag="h4">画像アップロード</a-heading>
      <!-- eslint-disable -->
      <a-text>必ずカラーでアップロードしてください。<br>STEP1の「契約情報の入力」で記入いただいた住所が確認できる書類をアップロードしてください。</a-text>
      <!-- eslint-enable -->
    </div>
    <form v-if="show_form" class="t-application-invite-user-upload__form" @submit.prevent="handleSubmitForm">
      <div class="t-application-invite-user-upload__fields">
        <template v-for="(document, index) in formData.documents" :key="index">
          <!-- <m-form-input :label="'画像データ' + (index + 1)"> -->
          <m-form-input>
            <a-select-field
              id="-uploadType"
              v-model="document.type"
              placeholder="書類の種類を選択してください"
              :options="documentTypeOptions"
              @change="handleChange"
            />
            <div class="t-application-invite-user-upload__field-uploads">
              <div
                v-for="(image, imageIndex) in document.images"
                :id="'imgbox_' + imageIndex"
                :key="imageIndex"
                class="t-application-invite-user-upload__field-uploads-col"
              >
                <a-upload-field
                  v-model="image.file"
                  label="ファイルをアップロード
してください。

※対応するファイル形式は
.jpeg .jpg .png .pdfです。"
                  accept="image/png, image/jpeg, application/pdf"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                />
              </div>
            </div>
          </m-form-input>
          <m-form-input v-if="businessType === 'individual'">
            <a-select-field
              id="-uploadType2"
              v-model="document.type2"
              placeholder="書類の種類を選択してください"
              :options="documentTypeOptions2"
              @change="handleChange2"
            />
            <div class="t-application-invite-user-upload__field-uploads">
              <div
                v-for="(image2, imageIndex) in document.images2"
                :id="'imgbox2_' + imageIndex"
                :key="imageIndex"
                class="t-application-invite-user-upload__field-uploads-col"
              >
                <a-upload-field
                  v-model="image2.file"
                  label="ファイルをアップロード
してください。

※対応するファイル形式は
.jpeg .jpg .png .pdfです。"
                  accept="image/png, image/jpeg, application/pdf"
                  @change="handleUploadFileChange(index, imageIndex + 2, image2.file)"
                />
              </div>
            </div>
          </m-form-input>
        </template>
      </div>
      <div class="t-application-invite-user-upload__buttons">
        <m-button-container>
          <!-- <a-button variant="block" submit="submit" color="primary">次へ</a-button> -->
          <a-button id="next" variant="block" submit="submit" color="primary" :disabled="!agree">次へ</a-button>
          <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-modal
        id="applicationInviteUserUpload_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import AUploadField from '@/components/atoms/upload-field';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';
import { IDENTIFICATION_OPTIONS, IDENTIFICATION_OPTIONS2, SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';
import { cloneDeep } from 'lodash';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';

import { utils } from '@/common/utils.js';

import Loading from 'vue-loading-overlay';

export default {
  name: 't-application-invite-user-upload',
  components: {
    TDefaultEntrySidebar,
    MFormInput,
    ASelectField,
    AButton,
    MButtonContainer,
    AUploadField,
    AHeading,
    AText,
    OModal,
    Loading,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 2,
        heading: '本人確認書類',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      documentTypeOptions: IDENTIFICATION_OPTIONS,
      documentTypeOptionsBase: IDENTIFICATION_OPTIONS2,
      documentTypeOptions2: IDENTIFICATION_OPTIONS2,
      formData: {
        documents: [
          {
            type: null,
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
            images2: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
      },
      tmpCompanyID: '',
      tmpDate: '',
      dirname: '',
      agree: false,
      businessType: '',
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      isLoading: false,
      certificateCollectionURL: {
        MyNumber: 'my_number_card',
        Driverlicense1: 'driver_license',
        Driverlicense2: 'driver_license',
        DrivingHistory1: 'driving_history',
        DrivingHistory2: 'driving_history',
        SealRegistration: 'seal_registration',
        FamilyRegister: 'family_register',
        CertificateOfResidence: 'Certificate_of_residence',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-upload');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    // ページ移動、リロードダイアログ表示
    window.addEventListener('beforeunload', this.confirmMove);

    document.title = '本人確認書類 | COTOHA Call Center';

    utils.setMetaDescription(this.$route);

    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }

    try {
      this.tmpCompanyID = this.tmpUUID;
      this.tmpDate = this.tmpYMD;

      if (!this.tmpCompanyID || !this.tmpDate) {
        throw new Error('Invalid data.');
      }
      // this.tmpCompanyID = 'tmp_f63a8ae7-e674-444e-8771-73ca32e2641b';
      // this.tmpDate = '20210427';

      this.dirname = this.tmpCompanyID;

      const result = await this.getHistoryDoc(this.tmpCompanyID, this.tmpDate);

      if (result.businessType !== 'individual' && result.businessType !== 'company') {
        throw new Error('businessType: Invalid data.');
      }
      this.businessType = result.businessType;

      if (result.businessType === 'company') {
        this.sidebarInfo.sidebarList[0] = { label: '契約情報の入力' };
        this.sidebarInfo.sidebarList[1] = { label: '本人確認書類' };
        this.sidebarInfo.sidebarList[2] = { label: '契約情報の入力(法人)' };
        this.sidebarInfo.sidebarList[3] = { label: '法人の確認書類' };
        this.sidebarInfo.sidebarList[4] = { label: '請求書送付先' };
        this.sidebarInfo.sidebarList[5] = { label: 'お申し込み内容確認' };
      }
    } catch (error) {
      console.log(error);
      this.showErrorModal(messageContent.requireTry('情報取得'));
    }

    this.show_form = true;
  },
  unmounted() {
    // ページ移動、リロードダイアログ解除
    window.removeEventListener('beforeunload', this.confirmMove);
  },
  methods: {
    confirmMove(e) {
      e.returnValue = '他のページに移動しますか？';
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    async handleSubmitForm(e) {
      // e.preventDefault();
      const payload = cloneDeep(this.formData);
      this.handleFormSubmit(payload);

      try {
        // 入力チェック
        const type = this.formData.documents[0].type;
        const type2 = this.formData.documents[0].type2;
        if (type === IDENTIFICATION_OPTIONS[0].value) {
          // console.log('運転免許証');
          if (!this.formData.documents[0].images[0].binary || !this.formData.documents[0].images[1].binary) {
            this.showErrorModal(messageContent.alertDriverLicense('運転免許証'));
            return;
          }

          // ファイルチェック
          const ret = this.filecheck(this.formData.documents[0].images, 2);
          if (ret === false) return;
        } else if (type === IDENTIFICATION_OPTIONS[1].value) {
          // console.log('マイナンバー');
          if (!this.formData.documents[0].images[0].binary) {
            this.showErrorModal(messageContent.alertMyNumberCard());
            return;
          }

          // ファイルチェック
          const ret = this.filecheck(this.formData.documents[0].images, 1);
          if (ret === false) return;
        } else {
          this.showErrorModal(messageContent.requireChoice('書類の種類'));
          return;
        }

        // 個人申し込みのみ2段目のチェック
        if (this.businessType === 'individual') {
          const matchNo = Object.keys(IDENTIFICATION_OPTIONS2).find(
            key => IDENTIFICATION_OPTIONS2[key].value === type2
          );

          if (type2 === 'driver_license' || type2 === 'driving_history') {
            if (!this.formData.documents[0].images2[0].binary || !this.formData.documents[0].images2[1].binary) {
              this.showErrorModal(
                messageContent.alertDriverLicense(IDENTIFICATION_OPTIONS2[matchNo].label.replace('(表裏2枚)', ''))
              );
              return;
            }

            // ファイルチェック（2箇所）
            const ret = this.filecheck(this.formData.documents[0].images2, 2);
            if (ret === false) return;
          } else {
            if (!this.formData.documents[0].images2[0].binary) {
              this.showErrorModal(
                messageContent.alertIdentification(IDENTIFICATION_OPTIONS2[matchNo].label.replace('(表のみ1枚)', ''))
              );
              return;
            }

            // ファイルチェック（1箇所）
            const ret = this.filecheck(this.formData.documents[0].images2, 1);
            if (ret === false) return;
          }
        }

        // delete old upload file
        const result = await this.getCertificateDoc(this.tmpCompanyID, this.tmpDate);
        for (const key in this.certificateCollectionURL) {
          let setKey = key + 'URL';
          setKey = setKey.replace('Driverlicense1URL', 'DriverlicenseURL1');
          setKey = setKey.replace('Driverlicense2URL', 'DriverlicenseURL2');
          if (typeof result[setKey] !== 'undefined' && result[setKey] !== '') {
            await this.deleteImage(result[setKey]);
          }
        }

        // #3627
        this.isLoading = true;
        // upload
        const url = new Map();
        for (let j = 0; j < 2; j++) {
          if (this.formData.documents[0].images[j].binary) {
            // ext
            const extList = this.formData.documents[0].images[j].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'png' && ext !== 'jpeg' && ext !== 'jpg' && ext !== 'pdf') {
              this.isLoading = false;
              this.showErrorModal(
                messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
              );
              return;
            }

            // filename
            let filename = '';
            if (type === IDENTIFICATION_OPTIONS[0].value) {
              const number = j + 1;
              filename = 'Driverlicense' + number;
            } else if (type === IDENTIFICATION_OPTIONS[1].value) {
              filename = 'MyNumber';
            }

            const result = await this.uploadImage(
              this.dirname + '/' + filename + '.' + ext,
              this.formData.documents[0].images[j].binary
            );

            if (result === 'error') {
              this.isLoading = false;
              this.showErrorModal(
                messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
              );
              return;
            }

            url.set(filename, result);
          }
        }

        for (let j = 0; j < 2; j++) {
          if (this.formData.documents[0].images2[j].binary) {
            // ext
            const extList = this.formData.documents[0].images2[j].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'png' && ext !== 'jpeg' && ext !== 'jpg' && ext !== 'pdf') {
              this.isLoading = false;
              this.showErrorModal(
                messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
              );
              return;
            }

            // filename
            let filename = Object.keys(this.certificateCollectionURL).find(
              key => this.certificateCollectionURL[key] === type2
            );

            if (filename === 'Driverlicense1' && j === 1) {
              filename = 'Driverlicense2';
            }

            if (filename === 'DrivingHistory1' && j === 1) {
              filename = 'DrivingHistory2';
            }

            const result = await this.uploadImage(
              this.dirname + '/' + filename + '.' + ext,
              this.formData.documents[0].images2[j].binary
            );

            if (result === 'error') {
              this.isLoading = false;
              this.showErrorModal(
                messageContent.requireChoice('対応する形式のファイル') + '<br><br>' + messageContent.fileFormat
              );
              return;
            }

            url.set(filename, result);
          }
        }

        const urlGet = {};
        for (const key in this.certificateCollectionURL) {
          urlGet[key] = url.get(key);
        }

        const ret = await this.setCertificateDoc(
          this.tmpCompanyID,
          this.tmpDate,
          this.formData.documents[0].type,
          this.formData.documents[0].type2,
          urlGet
        );

        if (ret === 'error') {
          throw new Error('/signup/setuploadfileinfo response was not ok.');
        }

        this.isLoading = false;
        if (this.businessType === 'individual') {
          this.$router.push({ name: 'SignupInvoice' });
        } else if (this.businessType === 'company') {
          this.$router.push({ name: 'SignupFormH' });
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.showErrorModal(messageContent.requireTry('ファイルのアップロード'));
      }
    },
    handleCancelClick() {
      this.$router.push({ name: 'SignupForm' });
    },
    handleUploadFileChange(documentIndex, imageIndex, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          if (imageIndex < 2) {
            vm.formData.documents[documentIndex].images[imageIndex].binary = content;
          } else {
            vm.formData.documents[documentIndex].images2[imageIndex - 2].binary = content;
          }
        },
        false
      );

      const type = this.formData.documents[0].type;
      const type2 = this.formData.documents[0].type2;

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        if (imageIndex < 2) {
          vm.formData.documents[documentIndex].images[imageIndex].filename = file[0].name;
          vm.formData.documents[documentIndex].images[imageIndex].size = file[0].size;
        } else {
          vm.formData.documents[documentIndex].images2[imageIndex - 2].filename = file[0].name;
          vm.formData.documents[documentIndex].images2[imageIndex - 2].size = file[0].size;
        }

        // アップロード画像が1枚の種類のとき
        if (document.getElementById('imgbox_1').style.display === 'none') {
          // 2段目のアップロードが運転免許証、運転経歴証明書以外のとき
          if (
            type !== null &&
            type2 !== undefined &&
            type2 !== 'driver_license' &&
            type2 !== 'driving_history' &&
            vm.formData.documents[documentIndex].images[0].filename !== null &&
            vm.formData.documents[documentIndex].images2[0].filename !== null
          ) {
            vm.agree = true;
            // 2段目のアップロードが運転免許証、運転経歴証明書のとき
          } else if (
            type !== null &&
            type2 !== undefined &&
            (type2 === 'driver_license' || type2 === 'driving_history') &&
            vm.formData.documents[documentIndex].images[0].filename !== null &&
            vm.formData.documents[documentIndex].images2[0].filename !== null &&
            vm.formData.documents[documentIndex].images2[1].filename !== null
          ) {
            vm.agree = true;
          }
          // アップロード画像が2枚の種類のとき
        } else {
          if (
            type !== null &&
            type2 !== undefined &&
            type2 !== 'driver_license' &&
            type2 !== 'driving_history' &&
            vm.formData.documents[documentIndex].images[0].filename !== null &&
            vm.formData.documents[documentIndex].images[1].filename !== null &&
            vm.formData.documents[documentIndex].images2[0].filename !== null
          ) {
            vm.agree = true;
            // 2段目のアップロードが運転免許証、運転経歴証明書のとき
          } else if (
            type !== null &&
            type2 !== undefined &&
            (type2 === 'driver_license' || type2 === 'driving_history') &&
            vm.formData.documents[documentIndex].images[0].filename !== null &&
            vm.formData.documents[documentIndex].images[1].filename !== null &&
            vm.formData.documents[documentIndex].images2[0].filename !== null &&
            vm.formData.documents[documentIndex].images2[1].filename !== null
          ) {
            vm.agree = true;
          }
        }

        if (this.businessType === 'company') {
          if (
            type === 'driver_license' &&
            vm.formData.documents[documentIndex].images[0].filename !== null &&
            vm.formData.documents[documentIndex].images[1].filename !== null
          ) {
            vm.agree = true;
          } else if (type === 'my_number_card' && vm.formData.documents[documentIndex].images[0].filename !== null) {
            vm.agree = true;
          }
        }
      } else {
        // clear file content
        if (imageIndex < 2) {
          vm.formData.documents[documentIndex].images[imageIndex].file = null;
          vm.formData.documents[documentIndex].images[imageIndex].filename = null;
          vm.formData.documents[documentIndex].images[imageIndex].binary = null;
          vm.formData.documents[documentIndex].images[imageIndex].size = null;
        } else {
          vm.formData.documents[documentIndex].images2[imageIndex - 2].file = null;
          vm.formData.documents[documentIndex].images2[imageIndex - 2].filename = null;
          vm.formData.documents[documentIndex].images2[imageIndex - 2].binary = null;
          vm.formData.documents[documentIndex].images2[imageIndex - 2].size = null;
        }

        // 1段目のアップロードが1つのとき
        if (document.getElementById('imgbox_1').style.display === 'none') {
          if (
            vm.formData.documents[documentIndex].images[0].filename === null ||
            vm.formData.documents[documentIndex].images2[0].filename === null ||
            vm.formData.documents[documentIndex].images2[1].filename === null
          ) {
            vm.agree = false;
          }
          // 1段目のアップロードが2つのとき
        } else {
          if (
            vm.formData.documents[documentIndex].images[0].filename === null ||
            vm.formData.documents[documentIndex].images[1].filename === null ||
            vm.formData.documents[documentIndex].images2[0].filename === null ||
            vm.formData.documents[documentIndex].images2[1].filename === null
          ) {
            vm.agree = false;
          }
        }

        if (this.businessType === 'company') {
          if (
            type === 'driver_license' &&
            (vm.formData.documents[documentIndex].images[0].filename === null ||
              vm.formData.documents[documentIndex].images[1].filename === null)
          ) {
            vm.agree = false;
          } else if (type === 'my_number_card' && vm.formData.documents[documentIndex].images[0].filename === null) {
            vm.agree = false;
          }
        }
      }
    },
    uploadImage(path, binary) {
      const format = this.getFileFormat(binary);

      if (format === 'unknown') {
        return 'error';
      }

      return this.postRequest('/signup/uploaddocument', {
        path: path,
        binary: binary,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/uploaddocument response was not ok.');
        }
        return e.result;
      });
    },
    deleteImage(path) {
      if (!path) {
        return false;
      }
      return this.postRequest('/signup/deletedocument', {
        path: path,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/deletedocument response was not ok.');
        }
        return e.result;
      });
    },
    setCertificateDoc(tmpCompanyID, date, certificateType, certificateType2, urlGet) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        certificateType: certificateType,
        certificateType2: certificateType2,
        urlGet: urlGet,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/setuploadfileinfo', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/setuploadfileinfo response was not ok.');
            }

            return e.result;
          } else {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          return 'error';
        });
    },
    getCertificateDoc(tmpCompanyID, date) {
      return this.postRequest('/signup/getcertificatedoc', {
        tmpCompanyID: tmpCompanyID,
        date: date,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/getcertificatedoc response was not ok.');
        }
        return e.result;
      });
    },
    getHistoryDoc(tmpCompanyID, date) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/gethistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/gethistorydoc response was not ok.');
            }
            return e.result;
          } else {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    handleChange() {
      const type = this.formData.documents[0].type;
      const type2 = this.formData.documents[0].type2;

      this.agree = false;
      if (
        type === 'driver_license' &&
        this.formData.documents[0].images[0].filename !== null &&
        this.formData.documents[0].images[1].filename !== null
      ) {
        this.agree = true;
      } else if (type === 'my_number_card' && this.formData.documents[0].images[0].filename !== null) {
        this.agree = true;
      }

      document.getElementById('imgbox_0').style.display = 'block';
      document.getElementById('imgbox_1').style.display = 'block';
      if (type === 'my_number_card') {
        document.getElementById('imgbox_1').style.display = 'none';
      }

      const documentTypeOptionsBase = cloneDeep(this.documentTypeOptionsBase);
      this.documentTypeOptions2 = documentTypeOptionsBase;
      for (const key in this.documentTypeOptions2) {
        if (this.documentTypeOptions2[key].value === type) {
          if (type === this.formData.documents[0].type2) {
            this.formData.documents[0].type2 = undefined;
          }
          this.documentTypeOptions2.splice(key, 1);
          break;
        }
      }

      if (this.businessType === 'individual' && (typeof type2 === 'undefined' || type === type2)) {
        this.agree = false;
      }
    },
    handleChange2() {
      const type = this.formData.documents[0].type;
      const type2 = this.formData.documents[0].type2;
      this.agree = false;

      if (
        type !== null &&
        type2 !== undefined &&
        type2 !== 'driver_license' &&
        type2 !== 'driving_history' &&
        this.formData.documents[0].images[0].filename !== null &&
        this.formData.documents[0].images2[0].filename !== null
      ) {
        this.agree = true;
      } else if (
        type !== null &&
        type2 !== undefined &&
        (type2 === 'driver_license' || type2 === 'driving_history') &&
        this.formData.documents[0].images[0].filename !== null &&
        this.formData.documents[0].images2[0].filename !== null &&
        this.formData.documents[0].images2[1].filename !== null
      ) {
        this.agree = true;
      }

      document.getElementById('imgbox2_0').style.display = 'block';
      document.getElementById('imgbox2_1').style.display = 'block';
      if (type2 !== 'driver_license' && type2 !== 'driving_history') {
        document.getElementById('imgbox2_1').style.display = 'none';
      }
    },
    getFileFormat(binary) {
      const string_of_binary = atob(binary);
      const ary = [];
      let header = '';

      for (let i = 0; i < 5; i++) {
        ary[i] = string_of_binary.charCodeAt(i);
        header += ary[i].toString(16);
      }

      switch (true) {
        case /^89504e47/.test(header):
          return 'image/png';
        case /^ffd8ff/.test(header):
          return 'image/jpeg';
        case /^255044462d/.test(header):
          return 'application/pdf';
        default:
          return 'unknown';
      }
    },
    filecheck(formDataImages, type) {
      // ファイルチェック
      let errType = 0;
      if (type === 1) {
        if (formDataImages[0].size !== null && formDataImages[0].size > 10485760) {
          errType = 1;
        }

        if (formDataImages[0].filename !== null && formDataImages[0].filename.length > 100) {
          errType = 2;
        }
      } else if (type === 2) {
        if (
          (formDataImages[0].size !== null && formDataImages[0].size > 10485760) ||
          (formDataImages[1].size !== null && formDataImages[1].size > 10485760)
        ) {
          errType = 1;
        }

        if (
          (formDataImages[0].filename !== null && formDataImages[0].filename.length > 100) ||
          (formDataImages[1].filename !== null && formDataImages[1].filename.length > 100)
        ) {
          errType = 2;
        }
      }

      if (errType === 1) {
        this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
        return false;
      } else if (errType === 2) {
        this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
        return false;
      }

      return true;
    },
  },
};
</script>
